const pageNameKey = "editUserDrawerModal";

export const editUserDrawerModalEn = {
  [pageNameKey]: {
    editUserTitle: "Edit user",
    userNameLabel: "User name",
    userNamePlaceholder: "Enter user name",
    givenNameLabel: "Given Name",
    givenNamePlaceholder: "Enter given name",
    familyNameLabel: "Family Name",
    familyNamePlaceholder: "Enter family name",
    emailLabel: "Email",
    emailPlaceholder: "Enter email address",
    updateUserButton: "Update User",
    cancelButton: "Cancel",
    rolesWarningText: "Please assign at least one role to the user.",
    inputsCheckWarningText: "Please fix the following fields: ",
    userCreatedSuccessText: "User updated successfully.",
    detailsAndStatusErrorText: "Failed to update user details and status",
    detailsErrorText: "Failed to update user details",
    statusErrorText: "Failed to update user status",
    userDataLoadingErrorText: "Failed to load user data: data could be stale.",
    activeStatusText: "Active",
    inactiveStatusText: "Inactive",
    initialStatusText: "Initial",
  },
};

export const editUserDrawerModalPtBr = {
  [pageNameKey]: {
    editUserTitle: "Editar usuário",
    userNameLabel: "Nome de usuário",
    userNamePlaceholder: "Digite o nome de usuário",
    givenNameLabel: "Nome",
    givenNamePlaceholder: "Digite o nome",
    familyNameLabel: "Sobrenome",
    familyNamePlaceholder: "Digite o sobrenome",
    emailLabel: "E-mail",
    emailPlaceholder: "Digite o endereço de e-mail",
    updateUserButton: "Atualizar usuário",
    cancelButton: "Cancelar",
    rolesWarningText: "Atribua pelo menos uma função ao usuário.",
    inputsCheckWarningText: "Corrija os seguintes campos: ",
    userCreatedSuccessText: "Usuário atualizado com sucesso.",
    detailsAndStatusErrorText:
      "Falha ao atualizar os detalhes e o status do usuário",
    detailsErrorText: "Falha ao atualizar os detalhes do usuário",
    statusErrorText: "Falha ao atualizar o status do usuário",
    userDataLoadingErrorText:
      "Falha ao carregar os dados do usuário: os dados podem estar desatualizados.",
    activeStatusText: "Ativo",
    inactiveStatusText: "Inativo",
    initialStatusText: "Inicial",
  },
};

export const editUserDrawerModalDe = {
  [pageNameKey]: {
    editUserTitle: "Benutzer bearbeiten",
    userNameLabel: "Benutzername",
    userNamePlaceholder: "Benutzernamen eingeben",
    givenNameLabel: "Vorname",
    givenNamePlaceholder: "Vornamen eingeben",
    familyNameLabel: "Nachname",
    familyNamePlaceholder: "Nachnamen eingeben",
    emailLabel: "E-Mail",
    emailPlaceholder: "E-Mail-Adresse eingeben",
    updateUserButton: "Benutzer aktualisieren",
    cancelButton: "Abbrechen",
    rolesWarningText: "Bitte mindestens eine Rolle für den Benutzer zuweisen.",
    inputsCheckWarningText: "Bitte beheben Sie die folgenden Felder: ",
    userCreatedSuccessText: "Benutzer erfolgreich aktualisiert.",
    detailsAndStatusErrorText:
      "Fehler beim Aktualisieren der Benutzerdaten und -status.",
    detailsErrorText: "Fehler beim Aktualisieren der Benutzerdaten.",
    statusErrorText: "Fehler beim Aktualisieren des Benutzerstatus.",
    userDataLoadingErrorText:
      "Fehler beim Laden der Benutzerdaten: Daten könnten veraltet sein.",
    activeStatusText: "Aktiv",
    inactiveStatusText: "Inaktiv",
    initialStatusText: "Initial",
  },
};

export const editUserDrawerModalZhHans = {
  [pageNameKey]: {
    editUserTitle: "编辑用户",
    userNameLabel: "用户名",
    userNamePlaceholder: "输入用户名",
    givenNameLabel: "名字",
    givenNamePlaceholder: "输入名字",
    familyNameLabel: "姓氏",
    familyNamePlaceholder: "输入姓氏",
    emailLabel: "电子邮件",
    emailPlaceholder: "输入电子邮件地址",
    updateUserButton: "更新用户",
    cancelButton: "取消",
    rolesWarningText: "请为用户分配至少一个角色。",
    inputsCheckWarningText: "请修正以下字段： ",
    userCreatedSuccessText: "用户更新成功。",
    detailsAndStatusErrorText: "更新用户详情和状态失败",
    detailsErrorText: "更新用户详情失败",
    statusErrorText: "更新用户状态失败",
    userDataLoadingErrorText: "加载用户数据失败：数据可能已过时。",
    activeStatusText: "活跃的",
    inactiveStatusText: "不活跃的",
    initialStatusText: "初始的",
  },
};

export const editUserDrawerModalIt = {
  [pageNameKey]: {
    editUserTitle: "Modifica utente",
    userNameLabel: "Nome utente",
    userNamePlaceholder: "Inserisci il nome utente",
    givenNameLabel: "Nome",
    givenNamePlaceholder: "Inserisci il nome",
    familyNameLabel: "Cognome",
    familyNamePlaceholder: "Inserisci il cognome",
    emailLabel: "Email",
    emailPlaceholder: "Inserisci l'indirizzo email",
    updateUserButton: "Aggiorna Utente",
    cancelButton: "Annulla",
    rolesWarningText: "Assegna almeno un ruolo all'utente.",
    inputsCheckWarningText: "Si prega di correggere i seguenti campi: ",
    userCreatedSuccessText: "L'utente è stato aggiornato con successo.",
    detailsAndStatusErrorText:
      "Impossibile aggiornare i dettagli e lo stato utente",
    detailsErrorText: "Impossibile aggiornare i dettagli dell'utente",
    statusErrorText: "Impossibile aggiornare lo stato utente",
    userDataLoadingErrorText:
      "Impossibile caricare i dati dell'utente: i dati potrebbero essere obsoleti.",
    activeStatusText: "Attivo",
    inactiveStatusText: "Inattivo",
    initialStatusText: "Iniziale",
  },
};

export const editUserDrawerModalEs = {
  [pageNameKey]: {
    editUserTitle: "Editar usuario",
    userNameLabel: "Nombre de usuario",
    userNamePlaceholder: "Ingrese el nombre de usuario",
    givenNameLabel: "Nombre",
    givenNamePlaceholder: "Introduzca el nombre",
    familyNameLabel: "Apellido",
    familyNamePlaceholder: "Introduce el apellido",
    emailLabel: "Correo electrónico",
    emailPlaceholder: "Introduce la dirección de correo electrónico",
    updateUserButton: "Actualizar usuario",
    cancelButton: "Cancelar",
    rolesWarningText: "Asigna al menos un rol al usuario.",
    inputsCheckWarningText: "Por favor, corrige los siguientes campos: ",
    userCreatedSuccessText: "Usuario actualizado correctamente.",
    detailsAndStatusErrorText:
      "No se pudieron actualizar los detalles y el estado del usuario",
    detailsErrorText: "No se pudieron actualizar los datos del usuario",
    statusErrorText: "No se pudo actualizar el estado del usuario",
    userDataLoadingErrorText:
      "No se pudieron cargar los datos del usuario: los datos podrían estar desactualizados.",
    activeStatusText: "Activo",
    inactiveStatusText: "Inactivo",
    initialStatusText: "Inicial",
  },
};

export const editUserDrawerModalNl = {
  [pageNameKey]: {
    activeStatusText: "Actief",
    cancelButton: "Annuleren",
    detailsAndStatusErrorText:
      "Fout bij het bewerken van de gebruikersgegevens en -status.",
    detailsErrorText: "Fout bij het bewerken van de gebruikersgegevens.",
    editUserTitle: "Gebruiker bewerken",
    emailLabel: "E-mailadres",
    emailPlaceholder: "E-mailadres invoeren",
    familyNameLabel: "Achternaam",
    familyNamePlaceholder: "Achternaam invoeren",
    givenNameLabel: "Voornaam",
    givenNamePlaceholder: "Voornaam invoeren",
    inactiveStatusText: "Inactief",
    initialStatusText: "Initieel",
    inputsCheckWarningText: "Corrigeer de volgende velden: ",
    rolesWarningText: "Wijs de gebruiker minimaal één rol toe.",
    statusErrorText: "Fout bij het bewerken van de gebruikersstatus.",
    updateUserButton: "Gebruiker bewerken",
    userCreatedSuccessText: "Gebruiker succesvol bijgewerkt.",
    userDataLoadingErrorText:
      "Fout bij het laden van de gebruikersgegevens: gegevens kunnen verouderd zijn.",
    userNameLabel: "Gebruikersnaam",
    userNamePlaceholder: "Gebruikersnaam invoeren",
  },
};

export const editUserDrawerModalTr = {
  [pageNameKey]: {
    activeStatusText: "Aktif",
    cancelButton: "İptal etmek",
    detailsAndStatusErrorText: "Kullanıcı ayrıntıları ve durumu güncellenemedi",
    detailsErrorText: "Kullanıcı ayrıntıları güncellenemedi",
    editUserTitle: "Kullanıcıyı düzenle",
    emailLabel: "E-posta",
    emailPlaceholder: "E-posta adresini girin",
    familyNameLabel: "Aile Adı",
    familyNamePlaceholder: "Aile adını girin",
    givenNameLabel: "İsim",
    givenNamePlaceholder: "Verilen adı girin",
    inactiveStatusText: "Etkin değil",
    initialStatusText: "İlk",
    inputsCheckWarningText: "Lütfen aşağıdaki alanları düzeltin:",
    rolesWarningText: "Lütfen kullanıcıya en az bir rol atayın.",
    statusErrorText: "Kullanıcı durumu güncellenemedi",
    updateUserButton: "Kullanıcıyı Güncelle",
    userCreatedSuccessText: "Kullanıcı başarıyla güncellendi.",
    userDataLoadingErrorText:
      "Kullanıcı verileri yüklenemedi: veriler eski olabilir.",
    userNameLabel: "Kullanıcı adı",
    userNamePlaceholder: "Kullanıcı adını girin",
  },
};
